export const HOME_ROUTE = '/';
export const ADMIN_ROUTE = '/administration';
export const LOGIN_ROUTE = '/administration_login';
export const BIOGRAPHY_ROUTE = '/biography';
export const PUBLIC_SERVICE_ROUTE = '/public_service';
export const STREAM_ROUTE = '/stream';
export const CONTACTS_ROUTE = '/contacts';
export const EVENTS_ROUTE = '/events';
export const LAST_NEWS_ROUTE = '/last_news';
export const CITY_NEWS_ROUTE = '/city_news';
export const PUBLIC_INFORMATION_ROUTE = '/public_info';
export const DECISION_PROCESS_ROUTE = '/application_templates';
export const PUBLIC_NOTICES_ROUTE = '/public_notices';
export const DECENTRALIZED_SERVICES_ROUTE = '/drcd_services';
export const ADMINISTRATIVE_COUNCIL_ROUTE = '/administrative_council';
export const ADMINISTRATIVE_APPARATUS_ROUTE = '/administrative_apparatus';
export const SUBDIVISIONS_ROUTE = '/subdivisions';
export const MUNICIPAL_ENTERPRISES_ROUTE = '/municipal_enterprises';
export const NGOV_ORGANIZATIONS_ROUTE = '/ngov_organizations';
export const ORGANIZATION_ROUTE = '/organization';
export const BUSINESS_ROUTE = '/business';
export const HISTORY_ROUTE = '/history';
export const PRESIDENTS_MESSAGE_ROUTE = '/message';
export const COUNCILLORS_LIST_ROUTE = '/councillors_list';
export const SPECIALIZED_COMMITTEES_ROUTE = '/specialized_committees';
export const REGULATIONS_ROUTE = '/regulations';
export const MEETINGS_ROUTE = '/meetings';
export const VERBAL_PROCEDURE_ROUTE = '/verbal_procedure';
export const DRAFT_DECISIONS_ROUTE = '/draft_decisions';
export const LOCAL_DECISIONS_ACTS_ROUTE = '/local_decisions_acts';
export const SPECIALIZED_COMMITTEES_MEETS_ROUTE = '/special_committees_meets';
export const SOCIAL_ECONOMIC_INDICATORS_ROUTE = '/economic_indicators';
export const DISTRICT_BUDGET_ROUTE = '/drcd_budget';
export const TOURISM_MARKETING_PLAN_ROUTE = '/plans_strategies';
export const MANAGEMENT_ROUTE = '/management';
export const TRANSPARENCY_ROUTE = '/transparency';
export const RECOMENDATIONS_ROUTE = '/recomendations';
export const VACANCIES_ROUTE = '/vacancies';
export const DISTRICT_DECISIONS_ROUTE = '/district_decisions';
export const DISTRICT_PROVISIONS_ROUTE = '/district_provisions';
export const APPLICATION_FORMS_ROUTE = '/application_forms';
export const INITIATING_PUBLIC_PRIVATE_PARTNERSHIPS_ROUTE = '/initiating_public_private_partnerships';
export const INITIATION_ROUTE = '/initiation';
export const POLICIES_STRATEGIES_ROUTE = '/policies_strategies';
export const PUBLIC_TRANSPORT_NETWORK_ROUTE = '/public_transport_network';
export const CONSULTATIONS_ROUTE = '/consultations';
export const PUBLIC_CONSULTATIONS_ROUTE = '/public_consultations';
export const LOCATION_IN_NUMBERSS_ROUTE = '/location_in_numbers';
export const SUCCESS_STORIES_ROUTE = '/success_stories';
export const LOCATION_DEVELOPMENT_STRATEGY_ROUTE = '/location_development_strategy';
export const KEY_SECTORS_ROUTE = '/key_sectors';
export const PARTNER_SUPPORTED_PROJECTS_ROUTE = '/partner_supported_projects';
export const STARTING_BUSINESS_ROUTE = '/starting_business';
export const TOURIST_ROUTES_ROUTE = '/sanitation';
export const HOTELS_ROUTE = '/mechanized_sanitation';
export const MUSEUMS_ROUTE = '/funeral_service';
export const PARKS_ROUTE = '/road_repair';
export const TOURIST_ACTIVITIES_ROUTE = '/road_marking';
export const HISTORIC_BUILDINGS_ROUTE = '/special_services';
export const MONUMENTS_ROUTE = '/car_parking';
export const NOTABLE_PERSONALITIES_ROUTE = '/notable_personalities';
export const FOR_KIDS_ROUTE = '/for_kids';
export const CHURCHES_MONASTERIES_ROUTE = '/churches_monasteries';
export const REPORTS_ROUTE = '/reports';
export const INFORMATION_ROUTE = '/information';
export const DECISIONS_ROUTE = '/decisions';
export const ANNOUNCEMENTS_ROUTE = '/announcements';
export const LOWER_HIERARCHICAL_ORGANS_ROUTE = '/lower_hierarchical_organs';
export const CECE_VERBAL_PROCEDURE_ROUTE = '/cece_verbal_procedure';
export const PHOTO_GALLERY_ROUTE = '/photo_gallery';
export const ONLINE_MEETING_ROUTE = '/online_meeting';
export const HEAD_ONLINE_ROUTE = '/head_online';
export const EVENT_PAGE_ROUTE = '/event';
export const EUROPEAN_PROJECTS_ROUTE = '/drcd_reports';
export const CITIZENS_HEARING_PROGRAM_ROUTE = '/citizens_hearing_program';
export const ACQUISITION_ROUTE = '/acquisition';
export const TENDERS_ROUTE = '/tenders';
export const COMMITTEE_MEETINGS_ROUTE = '/committee_meetings';
export const OTHER_ROUTE = '/other';
export const MAIN_BANNER_INFO = '/main_banner_info';
export const EXTRAORDINARY_COMMISSIONS_ROUTE = '/extraordinary_commissions';

export const LD_GENERAL_ROUTE = '/ld_general';
export const LD_LOCAL_PUBLIC_ADMINISTRATION_ROUTE = '/ld_local_public_administration';
export const LD_BUDGET_FINANCE_ROUTE = '/ld_budget_finance';
export const LD_COMMERCE_ROUTE = '/ld_commerce';
export const LD_LOCAL_TAXES_ROUTE = '/ld_local_taxes';
export const LD_CONSTRUCTION_ROUTE = '/ld_construction';
export const LD_EMPLOYMENT_RELATIONSHIPS_ROUTE = '/ld_employment_relationships';
export const LD_TAND_TENURE_ROUTE = '/ld_tand_tenure';
export const LD_ORGANIZING_TENDERS_ROUTE = '/ld_organizing_tenders';
export const LD_MANAGING_PUBLIC_HERITAGE_ROUTE = '/ld_managing_public_heritage';
export const LD_OTHER_DOMAINS_ROUTE = '/ld_other_domains';
